import { isMemberOf } from "../validation/narrow";

export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "image/heic",
  "image/heif",
] as const;

export const NORMALIZED_UPLOAD_IMAGE_TYPES = ["image/avif"] as const;

export const ACCEPTED_UPLOAD_IMAGE_TYPES = [
  ...ALLOWED_IMAGE_TYPES,
  ...NORMALIZED_UPLOAD_IMAGE_TYPES,
] as const;

export const UPLOAD_ACCEPT_ATTRIBUTE = ACCEPTED_UPLOAD_IMAGE_TYPES.join(",");

const IMAGE_TYPE_LABELS: Record<string, string> = {
  "image/jpeg": "JPEG",
  "image/png": "PNG",
  "image/webp": "WebP",
  "image/gif": "GIF",
  "image/heic": "HEIC",
  "image/heif": "HEIC",
  "image/avif": "AVIF",
};

export const ACCEPTED_UPLOAD_FORMAT_LABEL = Array.from(
  new Set(
    ACCEPTED_UPLOAD_IMAGE_TYPES.map(
      (mimeType) => IMAGE_TYPE_LABELS[mimeType] ?? mimeType,
    ),
  ),
).join(", ");

export const MAX_PHOTO_SIZE_BYTES = 25 * 1024 * 1024;

export const MAX_HEIC_CONVERSION_BYTES = 20 * 1024 * 1024;

export const PHOTO_NORMALIZATION_MIN_BYTES = 1.5 * 1024 * 1024;

export const MAX_PRODUCT_MEDIA_SIZE_BYTES = 5 * 1024 * 1024;

export const MAX_PRODUCT_PHOTOS = 6;

export const MAX_PHOTO_EDGE_PX = 2560;

export const MAX_PHOTO_AREA_PX = 100_000_000;

export function exceedsPhotoPixelBudget(width: number, height: number): boolean {
  return width * height > MAX_PHOTO_AREA_PX;
}

export function isAllowedImageType(mimeType: string): boolean {
  return isMemberOf(ALLOWED_IMAGE_TYPES, mimeType);
}

export function isAcceptedUploadImageType(mimeType: string): boolean {
  return isMemberOf(ACCEPTED_UPLOAD_IMAGE_TYPES, mimeType);
}

export function requiresUploadNormalization(mimeType: string): boolean {
  return isMemberOf(NORMALIZED_UPLOAD_IMAGE_TYPES, mimeType);
}
